import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-exercise-listing',
  templateUrl: './view-exercise-listing.component.html',
  styleUrls: ['./view-exercise-listing.component.scss']
})
export class ViewExerciseListingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
